import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getPublicClubMembers } from "@/app/api/dynabuy-back/api-club";
export const usePublicMemberList = (clubSlug, excludePresident) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== clubSlug) {
    t0 = ["club", clubSlug, "members"];
    $[0] = clubSlug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== clubSlug || $[3] !== excludePresident) {
    t1 = async () => getPublicClubMembers(clubSlug, {
      excludeClubPresident: excludePresident
    });
    $[2] = clubSlug;
    $[3] = excludePresident;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = {
      queryKey: t0,
      queryFn: t1
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};